import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GridService } from '../shared/grid/grid.service';
import {
  BulkAssignMappingRequest,
  BulkAssignResultItem,
  JobDictionaryMapping,
  JobMappingCandidate
} from '../models/jobDictionaryMapping.model';

@Injectable({
  providedIn: 'root'
})
export class JobDictionaryMappingService extends GridService<JobDictionaryMapping> {

  constructor(http: HttpClient) {
    super('JobDictionaryMapping', http);
  }

  getUnmappedCandidates(): Observable<JobMappingCandidate[]> {
    return this.http.get<JobMappingCandidate[]>(
      this.getApiUrl(`${this.controllerName}/GetUnmappedCandidates`)
    );
  }

  bulkAssign(request: BulkAssignMappingRequest): Observable<BulkAssignResultItem[]> {
    return this.http.post<BulkAssignResultItem[]>(
      this.getApiUrl(`${this.controllerName}/BulkAssign`),
      request
    );
  }

  updateMapping(mapping: JobDictionaryMapping): Observable<Object> {
    return this.update(mapping);
  }

  deleteMapping(id: string): Observable<Object> {
    return this.delete(id);
  }
}
